import { PencilIcon } from '@heroicons/react/24/outline'
import { useTranslation } from '../../core/hooks/useTranslation'

interface EditButtonProps<T = any> {
    onClick: (item: T) => void
    item: T
    className?: string
    showLabel?: boolean
}

export default function EditButton<T = any>({
    onClick,
    item,
    className = '',
    showLabel = true
}: EditButtonProps<T>) {
    const { t } = useTranslation()

    return (
        <button
            onClick={() => onClick(item)}
            className={`flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 hover:border-gray-400 transition-colors ${className}`}
            title={t('edit')}
        >
            <PencilIcon className="w-3.5 h-3.5" />
            {showLabel && <span>{t('edit')}</span>}
        </button>
    )
}

